import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import Profile from "../Profile/Profile";
import Settings from "../Profile/Settings";

import SwipeableViews from "react-swipeable-views";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useLocation } from "react-router-dom";

export default function ProfileTabs() {
    const theme = useTheme();
    const location = useLocation();
    const [tabValue, setTabValue] = useState(location.state?.tabValue || 0);
    const { t } = useTranslation("translation");

    const TabPanel = (props) => {
        const { children, value, index, ...other } = props;

        return (
            <Typography component="div" role="tabpanel" hidden={value !== index} id={`scrollable-auto-tabpanel-${index}`} aria-labelledby={`scrollable-auto-tab-${index}`} {...other}>
                <Box>{children}</Box>
            </Typography>
        );
    };

    const handleChange = (_event, newValue) => {
        setTabValue(newValue);
    };

    const a11yProps = (index) => {
        return {
            id: `scrollable-auto-tab-${index}`,
            "aria-controls": `scrollable-auto-tabpanel-${index}`,
        };
    };

    return (
        <div>
            <Box sx={{ width: "100%" }}>
                <Tabs value={tabValue} onChange={handleChange} centered>
                    <Tab label={t("Profile")} {...a11yProps(0)}></Tab>
                    <Tab label={t("Settings")} {...a11yProps(1)}></Tab>
                </Tabs>
            </Box>

            <SwipeableViews
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={tabValue}
                onChangeIndex={(value) => {
                    setTabValue(value);
                }}
                enableMouseEvents
            >
                <TabPanel value={tabValue} index={0} dir={theme.direction}>
                    {tabValue == 0 ? <Profile /> : null}
                </TabPanel>
                <TabPanel value={tabValue} index={1} dir={theme.direction}>
                    {tabValue == 1 ? <Settings /> : null}
                </TabPanel>
            </SwipeableViews>
        </div>
    );
}
